import { useState } from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useMutation } from "@apollo/client";
import { UPDATE_PRODUCT_PRICE } from "../../graphql";
import FormWithButtons from "../FormWithButttons/FormWithButtons";
import TaxEditorFields from "../TaxEditorFields/TaxEditorFields";

function ProductTaxEditor({
  productPriceToUpdateId,
  defaultTaxId,
  defaultTariffId,
  onSubmitButtonClicked,
  onCancelButtonClicked,
}) {
  const [updateProductPrice] = useMutation(UPDATE_PRODUCT_PRICE);
  const [selectedTaxes, setSelectedTaxes] = useState({
    selectedTax: undefined,
    selectedTariff: undefined,
  });
  const handleSelectChange = ({ inputName, inputValue }) => {
    setSelectedTaxes(prev => ({
      ...prev,
      [inputName]: inputValue,
    }));
  };

  const handleSubmit = async () => {
    if (!productPriceToUpdateId) {
      onSubmitButtonClicked?.(selectedTaxes);
      return;
    }
    const res = await updateProductPrice({
      variables: {
        where: {
          id: productPriceToUpdateId,
        },
        data: {
          FK_Tax: selectedTaxes.taxId,
          FK_Tariff: selectedTaxes.tariffId,
        },
      },
    });
    onSubmitButtonClicked?.({
      ...selectedTaxes,
      updateResponse: res?.productPriceUpdateResponse,
    });
  };

  const handleCancel = () => {
    onCancelButtonClicked?.(selectedTaxes);
  };

  return (
    <Box
      sx={{
        width: 448,
        padding: "18px",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ width: "24px", height: "24px", padding: "4px" }}
          onClick={handleCancel}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </Box>
      <Typography fontSize={16} fontWeight={600} variant="h3">
        Editar impuesto
      </Typography>
      <TaxEditorFields
        taxesFormValues={{
          taxId: selectedTaxes.selectedTax?.id || defaultTaxId,
          tariffId: selectedTaxes.selectedTariff?.id || defaultTariffId,
        }}
        onSelectChange={handleSelectChange}
      />
      <FormWithButtons
        buttonsAlignment="end"
        submitText="Guardar"
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      />
    </Box>
  );
}

ProductTaxEditor.propTypes = {
  onSubmitButtonClicked: PropTypes.func,
  onCancelButtonClicked: PropTypes.func,
  productPriceToUpdateId: PropTypes.number,
  defaultTaxId: PropTypes.number,
  defaultTariffId: PropTypes.number,
};

ProductTaxEditor.defaultProps = {
  onSubmitButtonClicked: undefined,
  onCancelButtonClicked: undefined,
  productPriceToUpdateId: undefined,
  defaultTaxId: undefined,
  defaultTariffId: undefined,
};

export default ProductTaxEditor;
